import React from 'react';
import { Bell, Bot, User } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

const tag = (iso) => { try { return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' }); } catch { return ''; } };
const zeit = (iso) => { try { return new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch { return ''; } };
const wer = (e, unterzeichner) => {
  const an = e.an && e.an !== 'alle' ? (unterzeichner || []).find((u) => u.id === e.an)?.name : null;
  return an ? ` an ${an}` : '';
};

export const ErinnerungenBadge = ({ v }) => {
  const liste = [...(v.erinnerungen || [])].sort((a, b) => new Date(b.am) - new Date(a.am));
  if (!liste.length) return null;
  const auto = liste.filter((e) => e.von === 'automatisch').length;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center gap-1 text-[11px] px-2.5 py-0.5 rounded-full border border-[#e0b56a]/60 bg-[#e0b56a]/10 text-[#7a5a22] hover:border-[#b8893d] transition-colors duration-200" data-testid={`sig-erinnerungen-${v.vorgang_id}`}>
          <Bell className="w-3 h-3" />{liste.length}× erinnert · zuletzt {tag(liste[0].am)}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-0" data-testid={`sig-erinnerungen-liste-${v.vorgang_id}`}>
        <div className="px-4 py-2.5 border-b border-gray-100 text-[11px] tracking-[0.2em] uppercase text-[#b8893d]">Erinnerungen</div>
        <ul className="max-h-64 overflow-auto divide-y divide-gray-50">
          {liste.map((e, i) => {
            const a = e.von === 'automatisch';
            const I = a ? Bot : User;
            return (
              <li key={i} className="flex items-start gap-2.5 px-4 py-2 text-xs" data-testid={`sig-erinnerung-${v.vorgang_id}-${i}`}>
                <I className={`w-3.5 h-3.5 mt-0.5 shrink-0 ${a ? 'text-[#b8893d]' : 'text-[#1B3A5C]'}`} />
                <span><span className="text-[#1B3A5C] font-medium">{a ? 'Automatisch' : e.von || 'Kanzlei'}</span>{wer(e, v.unterzeichner)}<span className="block text-gray-500">{zeit(e.am)}</span></span>
              </li>
            );
          })}
        </ul>
        <div className="px-4 py-2 border-t border-gray-100 text-[11px] text-gray-500">{auto} automatisch · {liste.length - auto} manuell</div>
      </PopoverContent>
    </Popover>
  );
};
